import { create } from 'superstruct';

import { URL_REPLACEMENT } from '$const';
import { get, patch } from '~services/api/methods';
import {
  MamAssetsValidator,
  MamAssetUrlValidator,
  PermissionsResponseValidator,
} from '~services/api/validators/MamAssets';

export enum MamAssetsApiKeysEnum {
  GetMamAssets = 'getMamAssets',
  GetMamAssetUrl = 'getMamAssetUrl',
}

export const getMamAssets = async (mamAssetIds: number[]) => {
  const requestUrl = `${URL_REPLACEMENT.SYMFONY_URL}/mamlibrary/downloads_list/${mamAssetIds.join(',')}`;
  const response = await get<MamAssetsDto>(requestUrl);
  return create(response, MamAssetsValidator);
};

export const getMamAssetUrl = async (mamAssetId: number) => {
  // ! Important ! The '-' prefix to the ID indicates that it is a MAM ID. (Negativ numbers = MAM, Positiv numbers = Drupal)
  const requestUrl = `${URL_REPLACEMENT.SYMFONY_URL}/downloads/url/-${mamAssetId}`;
  const response = await get<MamAssetUrlDto>(requestUrl);
  return create(response, MamAssetUrlValidator);
};

export const getMamAssetsPermissions = async (assetId: number) => {
  const requestUrl = `${URL_REPLACEMENT.SYMFONY_URL}/mam_security/asset_permissions/${assetId}`;
  const response = await get<PermissionsResponse>(requestUrl);
  return create(response, PermissionsResponseValidator);
};

export const updateMamAssetsPermissions = async (assetId: number, permissions: any) => {
  const requestUrl = `${URL_REPLACEMENT.SYMFONY_URL}/mam_security/asset_permissions/${assetId}`;

  return await patch<PermissionsResponse>(requestUrl, permissions);
};
